//
import SlServiceOrderModel from '@/models/Sale/SlServiceOrder'
import PrinterService from '@/services/printerApi'
import { splitDateTimeString } from '@/services/JSUtils'

//
export default class SlServiceOrderService {

  /**
   * 
   * @param {*} payload 
   */
  static isTesting() {
    return false
  }

  /**
   * 
   * @param {*} payload 
   */
  static change(payload = {}) {

    // test query
    if (this.isTesting()) {
      return this.changeTest()
    }

    // api query
    return this
      .model()
      .from()
      .many('change')
      .attach({
        comment                 : payload.comment,
        customer_id             : payload.customerId,
        default_branch_office_id: payload.defaultBranchOfficeId,
        dte_number              : payload.number,
        global_discount         : payload.globalDiscount,
        global_discount_amount  : payload.globalDiscountAmount,
        g_core_business_sii_id  : payload.gCoreBusinessSIIId,
        in                      : payload.in,
        is_ticket               : payload.isTicket,
        is_change               : true,
        pos_sale_type           : payload.posSaleType,
        sale_detail             : payload.saleDetail,
        seller_user_code        : payload.sellerUserCode,
        seller_user_id          : payload.sellerUserID,
        sucursal_id             : payload.sucursalId, // variable no usada en back tranquilo
        supervisor_user_code    : payload.supervisorUserCode,
        supervisor_user_id      : payload.supervisorUserID,
        total                   : payload.total,
      })
  }

  /**
   * 
   */
  static changeTest() {
    return Promise.resolve({
      http_status_code: 201,
      data: {
        created_at: {
          date: '',
        },
        sale_id: 189872,
        sale_id_formatted: 'SX000000189941',
        service_order_created_at: [],
        service_order_id: 2313,
        status: 'success',
        wh_dispatch_request_id: null,
      }
    })
  }

  /**
   *  Returns the model
   */
  static model() {
    return SlServiceOrderModel
  }

  /**
   * 
   * @param {*} payload 
   */
  static printByHtml(payload) {
    // console.log('print html')
    let wUrl = 'boleta2.html'
    let wTyp = '_blank'
    let wIns = window.open(wUrl, wTyp)
    Object.assign(wIns.window, payload)
  }

  /**
   * 
   * @param {*} payload 
   */
  static printByService(payload) {
    Promise
      .race([
        PrinterService.print(payload),
        PrinterService.timeout(),
      ])
      .catch((error) => {
        this.printByHtml(payload)
      })
  }
  
  /**
   * 
   * @param {*} code 
   * @param {*} date 
   * @param {*} mode 
   * @param {*} options 
   */
  static async printChangeTicket(code = '', date = null, mode = false, options = {}) {
    
    // init obj
    let obj = {}

    // debug
    console.log({ code, date, mode, options })

    // response
    let barcode             = String(code)
    let dateTime            = date 
    let quotationMode       = Boolean(mode)

    // global
    obj.slID                = quotationMode
    obj.quotation           = false
    obj.seller              = options.seller || 'Vendedor de Prueba'
    obj.quotationExpiration = null
    obj.isQuotation         = false

    // windows
    obj.closeTimeout  = process.env.VUE_APP_PRINTER_TIMEOUT
    obj.editMode      = false
    
    // items
    obj.barcode = barcode
    obj.items   = options.items

    // summary
    obj.total           = options.total
    obj.incomingDetail  = options.incomingDetail
    obj.incomingTotal   = options.incomingTotal
    obj.global_discount = { amount_discount: options.incomingTotal }
    obj.globalDiscount  = { amount_discount: options.incomingTotal }
    obj.dateTime        = { date: null, time: null }

    //
    if (dateTime) obj.dateTime = splitDateTimeString(dateTime)

    // header
    obj.subtitle    = `TICKET DE CAMBIO N°${ barcode.substr(2) }`
    obj.title       = options.companyBusinessName
    obj.RUT         = options.companyRut
    obj.activities  = options.companyCommercialBusiness
    obj.address     = options.companyAddress
    obj.typeCode    = 6
    obj.saleType    = options.invoice ? 'FACTURA' : 'BOLETA'

    // customer
    if (options.invoice) {
      obj.cRUT = options.customer.rut
      obj.cbusinessName = options.customer.business_name
      obj.cpersonName = options.customer.alias_name
      obj.cmail = options.customer.email_collection
      obj.cactivities = options.customer.core_business
      obj.caddress = ''
      obj.cphone = ''
    }

    // mock
    obj.mockData = {
      slID            : obj.slID,
      quotation       : false,
      seller          : obj.seller,
      closeTimeout    : process.env.VUE_APP_PRINTER_TIMEOUT,
      barcode,
      items           : obj.items,
      total           : obj.total,
      incomingDetail  : obj.incomingDetail,
      incomingTotal   : obj.incomingTotal,
      global_discount : { amount_discount: obj.incomingTotal },
      dateTime        : splitDateTimeString(dateTime),
      subtitle        : 'TICKET DE CAMBIO',
    }

    // html
    // this.printByHtml(obj)
    this.printByService(obj)
    // if (this.htmlPrint) {
    //     let win = window.open('boleta2.html', '_blank')
    //     Object.assign(win.window, obj)
    //     return true
    // } else {
    //     const data = cloneDeep(obj)
    //     data.items = this.items
    //     data.incomingDetail = this.incomingList
    //         .map((i) => {
    //             i.quantity = i.incomingQuantity
    //             i.subtotal = i.incomingQuantity * i.sale_price
    //             return i
    //         })
    //         .filter((i) => i.quantity)

    //     let timeout = () =>
    //         new Promise((resolve, reject) => {
    //             setTimeout(
    //                 () => reject('Tiempo de espera agotado'),
    //                 process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
    //                     ? parseInt(
    //                           process.env
    //                               .VUE_APP_PRINTER_SERVICE_TIMEOUT
    //                       )
    //                     : 8000
    //             )
    //         })
    //     let promise = Promise.race([printerApi.print(data), timeout()])
    //     let comp = null
    //     try {
    //         let comp = await promise
    //         return comp
    //     } catch (e) {
    //         console.log('ERROR', e)
    //         try {
    //             let win = window.open('boleta2.html', '_blank')
    //             Object.assign(win.window, obj)
    //             return true
    //         } catch (e) {
    //             return false
    //         }
    //     }
    // }
  }
}